module.exports = __webpack_public_path__ + "img/MTW.1120d486.jpg";